import type { UserResponse } from "@/lib/api/model/userResponse";

export function memberDisplayName(
  m: Pick<UserResponse, "first_name" | "last_name" | "email">,
): string {
  const name = [m.first_name, m.last_name].filter(Boolean).join(" ").trim();
  return name || m.email;
}
